// useDropboxImages.js
import { useEffect, useState, useCallback } from "react";
import { api } from "./pureFunctions";

const PAGE_SIZE = 50;
/* 
export const thumbUrl = (img, size = "w480h320") =>
   `/api/dropbox/thumbnail?path=${encodeURIComponent(img.path)}&rev=${img.rev}&size=${size}`; */

export const thumbUrl = (img, size = "w480h320") =>
   `${api.defaults.baseURL ?? ""}/api/dropbox/thumbnail?path=${encodeURIComponent(img.path)}&rev=${img.rev}&size=${size}`;

export function useDropboxImages(folder, subfolder) {
   const [allImages, setAllImages] = useState([]);
   const [loadedImages, setLoadedImages] = useState([]);
   const [loadingList, setLoadingList] = useState(true);
   const [error, setError] = useState(null);
   const [version, setVersion] = useState(0);

   useEffect(() => {
      if (!folder || !subfolder) return;
      setLoadingList(true);
      setAllImages([]);
      setLoadedImages([]);

      api(
         `/api/dropbox/folder-images/list?folder=${encodeURIComponent(folder)}&subfolder=${encodeURIComponent(subfolder)}`,
      )
         .then((data) => setAllImages(data?.data?.images ?? []))
         .catch((err) => {
            const body = err?.response?.data;
            console.log(err?.response?.status, body);
            setError(body?.detail || body?.message || err.message);
         })
         .finally(() => setLoadingList(false));
   }, [folder, subfolder, version]);

   const loadMore = useCallback(() => {
      setLoadedImages((prev) => {
         const next = allImages.slice(prev.length, prev.length + PAGE_SIZE);
         return [...prev, ...next.map((img) => ({ ...img, thumbnail: thumbUrl(img, undefined, version) }))];
      });
   }, [allImages, version]);

   const refresh = useCallback(() => setVersion(Date.now()), []);

   useEffect(() => {
      if (allImages.length > 0) loadMore();
   }, [allImages, loadMore]);

   const hasMore = loadedImages.length < allImages.length;

   return { loadedImages, setLoadedImages, hasMore, loadingList, loadingMore: false, loadMore, error, refresh };
}
